import { defineComponent as _defineComponent } from 'vue'
import { useStore, computed, useContext, onMounted } from '@nuxtjs/composition-api';
import TAccordion from '../atoms/t-accordion.vue';
import { State } from '~/store';

interface Props {
  instanceKey: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UserFolders',
  props: {
    instanceKey: null
  },
  setup(__props: any) {

const { $mzAnalyticsApi, route } = useContext();


const store = useStore<State>();
const userFolders = computed(() => store.getters.userFolders);
const foldersClick = () => {
  let productArea = 'hub';
  if (route.value.path.includes('/folder')) {
    productArea = 'profile';
  }

  $mzAnalyticsApi({
    event: 'click',
    name: 'folders',
    productArea,
  });
};

const toggleAddFolderModal = () => {
  store.dispatch('toggleAddFolderModal', true);
  let productArea = 'hub';
  if (route.value.path.includes('/folder')) {
    productArea = 'profile';
  }

  $mzAnalyticsApi({
    event: 'click',
    name: 'add_folder',
    productArea,
  });
};

onMounted(() => store.dispatch('loadUserFolders'));
const trackUserClick = (name: string, link: string) => {
  let productArea = 'hub';
  if (route.value.path.includes('/folder')) {
    productArea = 'profile';
  }

  $mzAnalyticsApi({
    event: 'click',
    name: 'folder_button',
    productArea,
  });
};

return { __sfc: true,$mzAnalyticsApi, route, store, userFolders, foldersClick, toggleAddFolderModal, trackUserClick, TAccordion }
}

})